<template>
  <div class="card card-height">
    <div class="table-responsive">
      <table class="table">
        <thead>
        <tr>
          <th>Date</th>
          <th>Invoice Number</th>
          <th>Invoice Type</th>
          <th>Order Type</th>
          <th>Client Name</th>
          <th>Business Unit</th>
          <th>Sales Person</th>
          <th class="text-right">Invoice Amount</th>
          <th class="text-right">VAT Amount</th>
          <th class="text-right">Total Amount</th>
          <th class="text-right">Bill Sett. Discount</th>
          <th class="text-right">Adjusted Amount</th>
          <th class="text-right">Net Collection</th>
          <th class="text-right">Due Amount</th>
          <th class="text-center">Payment Status</th>
          <th class="text-center action-th">Action</th>
        </tr>
        </thead>

        <tbody>
        <tr v-for="(item, i) in tableItems" :key="i">
          <td>{{ item.date }} </td>
          <td>
            <a href="javascript:void(0)" @click.stop="onClickAddNewButton(item)">{{ item.bill_number }}</a>
          </td>
          <td>{{ item.invoice_type }}</td>
          <td>{{ item.sales_order_master ? item.sales_order_master.sale_type_title : '' }}</td>
          <td>{{ item.contact_name }}</td>
          <td>{{ item.business_name }}</td>
          <td>{{ item.sr_name }}</td>
          <td class="text-right">{{ item.subtotal_amount }}</td>
          <td class="text-right">{{ item.vat_amount }}</td>
          <td class="text-right">{{ item.total_amount }}</td>
          <td class="text-right">{{ item.discount }}</td>
          <td class="text-right">{{ item.adjusted_amount - item.discount }}</td>
          <td class="text-right">{{ item.paid_amount }}</td>
          <td class="text-right">{{ getTotalDue(item) }}</td>
          <td class="text-center">{{ item.payment_status }}</td>
          <td class="text-center">
            <div class="d-flex justify-content-center gap-1">
              <button @click="onClickAddNewButton(item)" v-if="item.payment_status === 'DUE'" class="btn btn-outline-primary btn-sm btn-icon" title="Money Receipt">
                <i class="fas fa-plus"></i>
              </button>
              <button v-if="item.receipt_masters && item.receipt_masters.length" class="btn btn-outline-primary btn-sm btn-icon" title="Print Receipt" @click="goToPrintMoneyReceipt(item)">
                <i class="fas fa-print"></i>
              </button>
            </div>
          </td>
        </tr>
        <tr v-if="currentPage === lastPage">
          <td colspan="7"></td>
          <td class="text-right"> {{ totalValue && totalValue.total_subtotal_amount }}</td>
          <td class="text-right"> {{ totalValue && totalValue.total_vat_amount }}</td>
          <td class="text-right"> {{ totalValue && totalValue.total_sum_amount }}</td>
          <td class="text-right"> {{ totalValue && totalValue.total_discount_amount }}</td>
          <td class="text-right"> {{ totalValue && getTotalAdjustedAmount(tableItems) }}</td>
          <td class="text-right"> {{ totalValue && totalValue.total_paid_amount }}</td>
          <td class="text-right"> {{ totalValue && totalValue.total_due_amount }}</td>
          <td> </td>
          <td> </td>
        </tr>
        </tbody>
      </table>
      <p v-if="!tableItems.length" class="text-center mt-5">No data</p>
    </div>
    <MoneyReceiptPrint
        v-if="store.state.isModalOpenTwo"
        :moneyReceiptData="moneyReceiptData"
        :companyInfo="companyInfo"
    />
  </div>
</template>

<script setup>
import {useRoute, useRouter} from "vue-router";
import {ref, onMounted} from "vue";
import {useStore} from "vuex";
import MoneyReceiptPrint from '@/components/molecule/company/inventory/pending-money-receipt/MoneyReceiptPrint';
import handleCompany from "@/services/modules/company";

const props = defineProps({
  tableItems: {
    type: Array,
  },
  currentPage: Number,
  lastPage: Number,
  totalValue: Object,
})
const route = useRoute()
const router = useRouter()
const store = useStore()
const {fetchCompanyInfo} = handleCompany();

const companyInfo = ref({});
const moneyReceiptData = ref([]);

onMounted(() => {
  fetchCompanyInfo(route.params.companyId).then((res) => {
    companyInfo.value = res.data;
  }).catch((error) => {
    console.log(error);
  });
});

const onClickAddNewButton = (item) =>  {
  let query = {
   saleMasterId:item.id,
   contactId:item.contact_profile_id,
   type:'pending-money-receipt',
   start:route.query.start,
   end:route.query.end,
   page:route.query.page,
  }
  return router.push({name: 'sales-invoice-receipt', params: route.params, query: query})
}

const getTotalDue = (item) => {
  return parseFloat(item.total_amount) - (parseFloat(item.paid_amount) + parseFloat(item.adjusted_amount))
}

const getTotalAdjustedAmount = (items) => {
  return items.reduce((total, saleMaster) => total + (saleMaster.adjusted_amount - saleMaster.discount), 0);
}

const goToPrintMoneyReceipt = (item) => {
  moneyReceiptData.value = item.receipt_masters && item.receipt_masters.length ? item.receipt_masters : [];
  store.state.isModalOpenTwo = true;
}

</script>

<style scoped>
.mr-5 {
  margin-right: 5px;
}
.action-th {
  width: 20%;
  text-align: center;
}
.name {
  width: 15%;
}
.action{
  text-align: center;
}

</style>